import { IOrder } from '../../../types/store';
import { isValidEmail } from './validation';
import { IQuote } from '../../../../Quotes/types/store';

export const isComplete = (order: IOrder, quote: IQuote): boolean => {
  const { ddosProtection } = order;

  if (
    quote.ddosProtection && ["Tier 1"].includes(quote.ddosProtection) &&
    !isValidEmail(ddosProtection?.reportingEmail1)
  ) {
    return false;
  }

  if (
    quote.ddosProtection && ["Tier 2", "Tier 3"].includes(quote.ddosProtection) &&
    (!isValidEmail(ddosProtection?.reportingEmail1) 
    // || !isValidEmail(ddosProtection?.reportingEmail2)
    // || !isValidEmail(ddosProtection?.reportingEmail3)
    )
  ) {
    return false;
  }

  {/* Portal Access - Disabled for v1 */}
  /*if (
    quote.ddosProtection && ["Tier 2", "Tier 3"].includes(quote.ddosProtection) &&
    (!isValidEmail(ddosProtection?.portalAccessEmail1)
    // || !isValidEmail(ddosProtection?.portalAccessEmail2)
    // || !isValidEmail(ddosProtection?.portalAccessEmail3)
    )
  ) {
    return false;
  }*/

  return true;
};
